import {mapMutations, mapState} from "vuex";
import {ApiUtils} from "@/utils/ApiUtils";

export default {
    data(vm){
      return {
          eventDetails: null,
          loadEventDetailsCallback: vm.hideClientList
      }
    },
    methods: {
        ...mapMutations('clientAttention', [
            'setLoading',
        ]),
        async loadEventInfo(silent = false){

            var vm = this
            const currentEvent = vm.selectedEvent

            if(!currentEvent) return

            if(!silent){
                vm.setLoading(true)
            }
            const response = await ApiUtils.makeGet(`schedule/event/${currentEvent.id}`)


            if(!response.ok){
                vm.loadingEvent = false
                vm.setLoading(false)
                const json = await response.json()
                vm.showSnackBar(json.message || 'Ha ocurrido un error intentando consultar los datos')
                return
            }

            const json = await response.json()
            vm.eventDetails = JSON.parse(JSON.stringify(json.result.event))
            vm.$nextTick(function(){
                vm.setLoading(false)
            })

        },
    },
    computed:{
        ...mapState('clientAttention', {
            currentEvent: state => state.currentEvent
        }),
    },
    watch:{
        currentEvent(event){
            var vm = this
            if(event){
                vm.selectedEvent = JSON.parse(JSON.stringify(event))
                vm.$nextTick(function(){
                    vm.loadEventInfo()
                })
            }else{
                vm.eventDetails = null
                vm.selectedEvent = null
            }
            vm.loadEventDetailsCallback()
        }
    }
}
